export default __webpack_public_path__ + "static/media/preciosReg_leed_febENG_b.e14e4779.png";